import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { MgButtonModule } from '@app/src/app/button';
import { AddressModule } from '@app/src/app/components/Input/Address';
import { FileInputModule } from '@app/src/app/components/Input/FileInput';
import { FileUploadModule } from '@app/src/app/components/Input/FileUpload';
import { MingaIdentityModule } from '@app/src/app/components/MingaIdentity';
import { SaveCancelDialogModule } from '@app/src/app/dialog/SaveCancel';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgEllipsisModule } from '@app/src/app/elements/MgEllipsis';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { LayoutLegacyContentModule } from '@modules/layout/components/layout-legacy-content/layout-legacy-content.module';

import { GenericModule } from '@shared/components/generic';
import { CommonFormModules } from '@shared/modules';

import { MingaProfileComponent } from './minga-profile.component';
import { MINGA_PROFILE_ROUTES } from './minga-profile.routes';

@NgModule({
  declarations: [MingaProfileComponent],
  imports: [
    // Routing
    RouterModule.forChild(MINGA_PROFILE_ROUTES),

    // Common Modules
    CommonFormModules,

    // Minga dependencies
    MgAvatarModule,
    FileInputModule,
    FileUploadModule,
    MgSpinnerModule,
    AddressModule,
    MgButtonModule,
    MgEllipsisModule,
    MgPipesModule,
    MingaIdentityModule,
    MgFormFieldModule,
    SaveCancelDialogModule,
    PermissionsModule,
    GenericModule,
    LayoutLegacyContentModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    FormsModule,
  ],
  exports: [RouterModule],
})
export class MingaProfileModule {}
